import { ArrowRight } from './arrow-right-icon';
import { ArrowLeft } from './arrow-left-icon';
import { ArrowDownCircle } from './arrow-down-circle-icon';
import { ArrowLeftCircle } from './arrow-left-circle-icon';
import { ArrowRightCircle } from './arrow-right-circle-icon';
import { ArrowUpCircle } from './arrow-up-circle-icon';
import { Hamburger } from './hamburger-icon';
import { ChatBubble } from './chat-bubble-icon';
import { ChevronLeft } from './chevron-left-icon';
import { ChevronLeftCircle } from './chevron-left-circle-icon';
import { ChevronRight } from './chevron-right-icon';
import { ChevronRightCircle } from './chevron-right-circle-icon';
import { ChevronDownIcon } from './chevron-down-icon';
import { ChevronDownCircle } from './chevron-down-circle-icon';
import { ChevronUpCircle } from './chevron-up-circle-icon';
import { ChevronUpIcon } from './chevron-up-icon';
import { Cross } from './cross-icon';
import { CrossCircle } from './cross-circle-icon';
import { DownloadCircle } from './download-circle-icon';
import { Download } from './download-icon';
import { Envelope } from './envelope-icon';
import { FrameCircle } from './frame-circle-icon';
import { Fullscreen } from './fullscreen-icon';
import { InfoCircleIcon } from './info-circle-icon';
import { InfoCircleFilledIcon } from './info-circle-filled-icon';
import { LeaveFullscreen } from './leave-fullscreen-icon';
import { LinkChain } from './link-chain-icon';
import { PdfDocument } from './pdf-document-icon';
import { PersonCircle } from './person-circle-icon';
import { PlayCircle } from './play-circle-icon';
import { PlusCircle } from './plus-circle-icon';
import { RadarCircle } from './radar-circle-icon';
import { SearchCircle } from './search-circle-icon';
import { ShareCircle } from './share-circle-icon';
import { TargetCircle } from './target-circle-icon';
import { ThreeLines } from './three-lines-icon';
import { ThreeNodesCircle } from './three-nodes-circle-icon';
import { Thumbnails } from './thumbnails-icon';
import { Tick } from './tick-icon';
import { TickCircle } from './tick-circle-icon'; // --------------- Social --------------->

import { Facebook, FacebookCircle, Twitter, TwitterCircle, Linkedin, LinkedinCircle, Youtube } from './social';
var Social = {
  Facebook: Facebook,
  FacebookCircle: FacebookCircle,
  Twitter: Twitter,
  TwitterCircle: TwitterCircle,
  Linkedin: Linkedin,
  LinkedinCircle: LinkedinCircle,
  Youtube: Youtube
}; // -------------- Platforms ---------->

import { Ecosystems, Education, Energy, IndigenousAffairs, Philanthropy, Sport } from './platforms';
var Platforms = {
  Ecosystems: Ecosystems,
  Education: Education,
  Energy: Energy,
  IndigenousAffairs: IndigenousAffairs,
  Philanthropy: Philanthropy,
  Sport: Sport
}; // --------------- SDGs --------------->

import { AffordableCleanEnergy, CleanerWaterSanitation, ClimateAction, DecentWorkAndEconomicGrowth, GenderEquality, GoodHealthAndWellbeing, IndustryInnovationAndInfrastructure, LifeBelowWater, LifeOnLand, NoPoverty, Partnerships, PeaceJusticeAndStrongInstitutions, QualityEducation, ReducedInequalities, ResponsibleConsumptionAndProduction, SustainableCitiesAndCommunities, ZeroHunger } from './sdg';
var Sdg = {
  AffordableCleanEnergy: AffordableCleanEnergy,
  CleanerWaterSanitation: CleanerWaterSanitation,
  ClimateAction: ClimateAction,
  DecentWorkAndEconomicGrowth: DecentWorkAndEconomicGrowth,
  GenderEquality: GenderEquality,
  GoodHealthAndWellbeing: GoodHealthAndWellbeing,
  IndustryInnovationAndInfrastructure: IndustryInnovationAndInfrastructure,
  LifeBelowWater: LifeBelowWater,
  LifeOnLand: LifeOnLand,
  NoPoverty: NoPoverty,
  Partnerships: Partnerships,
  PeaceJusticeAndStrongInstitutions: PeaceJusticeAndStrongInstitutions,
  QualityEducation: QualityEducation,
  ReducedInequalities: ReducedInequalities,
  ResponsibleConsumptionAndProduction: ResponsibleConsumptionAndProduction,
  SustainableCitiesAndCommunities: SustainableCitiesAndCommunities,
  ZeroHunger: ZeroHunger
}; // --------------- ENTITIES --------------->

import { Cluster, Economy, Event, ImpactStory, Indicator, ImpactResultType, KeyIssue, Organisation, Person, Sdg as SdgIcon, Video } from './entities';
var Entities = {
  Entity: FrameCircle,
  Cluster: Cluster,
  Economy: Economy,
  Event: Event,
  Indicator: Indicator,
  ImpactResultType: ImpactResultType,
  ImpactStory: ImpactStory,
  KeyIssue: KeyIssue,
  Organisation: Organisation,
  Observation: Event,
  Person: Person,
  Reason: KeyIssue,
  Sdg: SdgIcon,
  Video: Video,
  DeclineCause: FrameCircle,
  Methodology: Cluster,
  ImpactType: ImpactResultType,
  EcologicalPrinciple: TickCircle
}; // --------------- EXPORT SET -------------->

export var Icons = {
  ArrowDownCircle: ArrowDownCircle,
  ArrowLeftCircle: ArrowLeftCircle,
  ArrowRightCircle: ArrowRightCircle,
  ArrowUpCircle: ArrowUpCircle,
  ArrowLeft: ArrowLeft,
  ArrowRight: ArrowRight,
  ChatBubble: ChatBubble,
  ChevronDownIcon: ChevronDownIcon,
  ChevronUpIcon: ChevronUpIcon,
  ChevronLeft: ChevronLeft,
  ChevronLeftCircle: ChevronLeftCircle,
  ChevronRight: ChevronRight,
  ChevronRightCircle: ChevronRightCircle,
  ChevronDownCircle: ChevronDownCircle,
  ChevronUpCircle: ChevronUpCircle,
  CrossCircle: CrossCircle,
  Cross: Cross,
  InfoCircleIcon: InfoCircleIcon,
  InfoCircleFilledIcon: InfoCircleFilledIcon,
  DownloadCircle: DownloadCircle,
  Download: Download,
  Entities: Entities,
  Envelope: Envelope,
  FrameCircle: FrameCircle,
  Fullscreen: Fullscreen,
  Hamburger: Hamburger,
  LeaveFullscreen: LeaveFullscreen,
  LinkChain: LinkChain,
  PdfDocument: PdfDocument,
  PersonCircle: PersonCircle,
  PlayCircle: PlayCircle,
  PlusCircle: PlusCircle,
  RadarCircle: RadarCircle,
  Sdg: Sdg,
  SearchCircle: SearchCircle,
  ShareCircle: ShareCircle,
  Social: Social,
  TargetCircle: TargetCircle,
  ThreeLines: ThreeLines,
  ThreeNodesCircle: ThreeNodesCircle,
  Thumbnails: Thumbnails,
  Tick: Tick,
  TickCircle: TickCircle,
  Platforms: Platforms
};